import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import axios from "axios";
import moment from "moment";
import { URL } from "./apiurl";

export const handleGetSyncData = createAsyncThunk(
  "data/fetchData",
  async (status) => {
    const response = await axios.post(URL.HOMECOLLECTION_SEARCH_GETDATA, {
      CompanyId: window?.localStorage?.getItem("CompanyID"),
      DateOption: "hc.AppID",
      FromDate: moment().format("DD/MMM/YYYY"),
      ToDate: moment(new Date(), "YYYY-MM-DD;hh:mm:ss")
        .add("1", "weeks")
        .format("DD/MMM/YYYY"),
      FromTime: "00:00:00",
      ToTime: "23:59:59",
      StateId: "",
      CityId: "",
      AreaId: "",
      PinCode: "",
      CentreId: "",
      PhelboId: "",
      RouteId: "",
      PName: "",
      Mobile: "",
      PreBookingId: "",
      Status: status,
    });
    return response.data;
  }
);

export const handlePatientDetails = createAsyncThunk(
  "data/PatientDetails",
  async (payload) => {
    const response = await axios.post(
      URL.HOMECOLLECTION_EDIT_APPOINTMENT,
      payload
    );
    return response.data;
  }
);

export const handlePatientTestDetails = createAsyncThunk(
  "data/PatientTestDetails",
  async (payload) => {
    const response = await axios.post(
      URL.HOMECOLLECTION_SEARCH_BINDITEMDETAIL,
      payload
    );
    return response.data;
  }
);

export const handleAddPatient = createAsyncThunk(
  "data/addPatient",
  async (payload) => {
    const response = await axios.post(URL.BIND_OLD_PATIENT, {
      mobile: payload,
      CompanyId: window?.localStorage?.getItem("CompanyID"),
    });
    return response.data;
  }
);

const initialState = {
  error: false,
  loading: false,
  success: false,
  data: [],
  singleDetail: {},
  patientInfo: [],
  PatientDetails: {},
  PatientTestDetails: [],
};

export const getSyncData = createSlice({
  name: "patientInfoDetails",
  initialState: initialState,
  extraReducers: (builder) => {
    // handleGetSyncData
    builder.addCase(handleGetSyncData.pending, (state, action) => {
      state.data = [];
      state.loading = true;
    });
    builder.addCase(handleGetSyncData.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action?.payload?.message;
    });
    builder.addCase(handleGetSyncData.rejected, (state, action) => {
      state.loading = false;
    });

    // handleAddPatient
    builder.addCase(handleAddPatient.pending, (state, action) => {
      state.loading = true;
      state.patientInfo = [];
    });
    builder.addCase(handleAddPatient.fulfilled, (state, action) => {
      state.loading = false;
      state.patientInfo = action?.payload?.message;
    });
    builder.addCase(handleAddPatient.rejected, (state, action) => {
      state.loading = false;
    });

    // handlePatientDetails
    builder.addCase(handlePatientDetails.pending, (state, action) => {
      state.loading = true;
      state.PatientDetails = {};
    });
    builder.addCase(handlePatientDetails.fulfilled, (state, action) => {
      state.loading = false;
      state.PatientDetails = action?.payload?.message[0];
    });
    builder.addCase(handlePatientDetails.rejected, (state, action) => {
      state.loading = false;
    });

    // handlePatientTestDetails
    builder.addCase(handlePatientTestDetails.pending, (state, action) => {
      state.loading = true;
      state.PatientTestDetails = [];
    });
    builder.addCase(handlePatientTestDetails.fulfilled, (state, action) => {
      state.PatientTestDetails = action?.payload?.message.map((item) => ({
        ...item,
        IsNew: 0,
      }));
    });
    builder.addCase(handlePatientTestDetails.rejected, (state, action) => {
      state.loading = false;
    });
  },

  reducers: {
    resetPatientInfo: (state) => {
      let states = current(state);
      return (states = { ...states, patientInfo: [] });
    },
  },
});

// this is for dispatch
export const { resetPatientInfo, AddPatientInfo } = getSyncData.actions;

// this is for configureStore
export default getSyncData.reducer;
